
import request from '@/api/request'

// 邀新统计
export function getNewOrderActivity(activityId) {
  return request({
      url: `/activity/invite-new-order-activity/count/${activityId}`,
      method: 'get',
  });
}

// 获取有效活动
export function getActivateActivity() {
  return request({
      url: `/activity/invite-new-order-activity/getActivateActivity`,
      method: 'get',
  });
}

// 获取小程序邀请码
export function getMiniCode() {
  return request({
      url: `/activity/invite-new-order-activity/getMiniCode`,
      method: 'get',
  });
}


// 获取我的邀请码
export function inviteCodeString() {
  return request({
      url: `/activity/invite-new-order-activity/inviteCodeString`,
      method: 'get',
  });
}





